// @ts-check
// Normalización de errores de red/API (03-frontend §9.1). No se pierde
// status/request_id; nunca se expone el mensaje técnico crudo del backend.

/** @typedef {'network_error'|'timeout'|'unauthorized'|'forbidden'|'not_found'|'conflict'|'validation_error'|'rate_limited'|'server_error'|'unexpected_error'} ApiErrorKind */

export class ApiError extends Error {
  /**
   * @param {ApiErrorKind} kind
   * @param {{ status?: number, requestId?: string, code?: string, title?: string }} [details]
   */
  constructor(kind, details = {}) {
    super(`api_error:${kind}`);
    this.name = 'ApiError';
    this.kind = kind;
    this.status = details.status;
    this.requestId = details.requestId;
    this.code = details.code;
    /**
     * Mensaje del servidor apto para enseñar al usuario (`ErrorResponse.title`).
     * `undefined` si la respuesta no traía cuerpo JSON con `title`.
     *
     * Solo debe usarse donde el status por sí solo sea AMBIGUO (un 409 que
     * significa tres cosas distintas, por ejemplo). Para el resto, cada
     * pantalla sigue redactando su propio mensaje: es la que sabe qué estaba
     * intentando hacer el alumno.
     */
    this.title = details.title;
  }
}

/**
 * Clasifica un status HTTP en un tipo de error de aplicación (§8.4).
 * @param {number} status
 * @returns {ApiErrorKind}
 */
export function classifyStatus(status) {
  if (status === 401) return 'unauthorized';
  if (status === 403) return 'forbidden';
  if (status === 404) return 'not_found';
  if (status === 409) return 'conflict';
  if (status === 422) return 'validation_error';
  if (status === 429) return 'rate_limited';
  if (status >= 500) return 'server_error';
  return 'unexpected_error';
}
